/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedForeignStatusDropdown200,
  GetApiV1PersonSharedForeignStatusDropdown401,
  GetApiV1PersonSharedForeignStatusDropdown500,
  GetApiV1PersonSharedForeignStatusDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedForeignStatusDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedForeignStatusDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1PersonSharedForeignStatusDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedForeignStatusDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedForeignStatusDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedForeignStatusDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedForeignStatusDropdown500>;

export const getApiV1PersonSharedForeignStatusDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedForeignStatusDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedForeignStatusDropdownQueryResponse>;
